import Icon  from '@material-ui/icons/AirlineSeatReclineExtra';
import ProcessingList from './ProcessingList';
import ProcessingEdit from './ProcessingEdit';
import ProcessingView from './ProcessingView'


export default {
    list: ProcessingList,
    show: ProcessingView,
    edit: ProcessingEdit,
    icon: Icon,
};